export const uk = {
    'block-errors': {
        one: 'В блоке есть {count} ошибка',
        some: 'В блоке есть {count} ошибки',
        many: 'В блоке есть {count} ошибок',
        none: 'В блоке есть {count} ошибок'
    },
    'one-block-error': 'В блоке есть ошибка'
};
